<div class=" pt-2 px-1">

    <div class="page-header">

        <div>
            <h2>Agent Onboarding Status</h2>
        </div>

        <div class="progress-box">

            <div class="progress-text">
                {{progress}}% Completed
            </div>

            <div class="progress-bar">

                <div class="progress-fill"
                     [style.width.%]="progress">
                </div>

            </div>

        </div>

    </div>


    <!-- =================== KYC =================== -->

    <div class="section-card">

        <div class="section-header">

            <div class="section-title">
                🔐 KYC Verification
            </div>

            <span class="badge"
                  [ngClass]="getClass(data.KYC_Status)">

                {{getStatus(data.KYC_Status)}}

            </span>

        </div>

        <div class="section-body">

            <div class="status-row"
                 *ngFor="let item of kycItems">

                <div class="left">

                    {{item.title}}

                </div>

                <div class="right">

                    <span class="icon">

                        {{getIcon(data[item.key])}}

                    </span>

                    <span class="badge"
                          [ngClass]="getClass(data[item.key])">

                        {{getStatus(data[item.key])}}

                    </span>

                </div>

            </div>

        </div>

    </div>



    <!-- =================== Bank =================== -->

    <div class="section-card">

        <div class="section-header">

            <div class="section-title">

                🏦 Bank Details

            </div>

        </div>

        <div class="section-body">

            <div class="status-row">

                <div class="left">

                    Bank Verification

                </div>

                <div class="right">

                    <span class="icon">

                        {{getIcon(data.BNK_Status)}}

                    </span>

                    <span class="badge"
                          [ngClass]="getClass(data.BNK_Status)">

                        {{getStatus(data.BNK_Status)}}

                    </span>

                </div>

            </div>

        </div>

    </div>



    <!-- =================== Training =================== -->

    <div class="section-card">

        <div class="section-header">

            <div class="section-title">

                📚 Training

            </div>

            <span class="badge"
                  [ngClass]="getClass(data.TRN_Status)">

                {{getStatus(data.TRN_Status)}}

            </span>

        </div>


        <div class="section-body">

            <div class="status-row"
                 *ngFor="let item of trainingItems">

                <div class="left">

                    {{item.title}}

                </div>

                <div class="right">

                    <span class="icon">

                        {{getIcon(data[item.key])}}

                    </span>

                    <span class="badge"
                          [ngClass]="getClass(data[item.key])">

                        {{getStatus(data[item.key])}}

                    </span>

                </div>

            </div>


            <!-- <div class="status-row no-border">

                <div class="left">

                    Training End Date

                </div>

                <div class="right">

                    {{data.TrainingEndAt | date:'dd MMM yyyy'}}

                </div>

            </div> -->

        </div>

    </div>



    <!-- =================== Exam =================== -->

    <div class="section-card">

        <div class="section-header">

            <div class="section-title">

                📝 Exam

            </div>

            <span *ngIf="data.EXM_Status == 1">
                <app-custom-button text="Download Certificate" [width]="'max-content'" className="" [height]="'34px'" leadingIconName="" (onClick)="download()"></app-custom-button>
            </span>

        </div>


        <div class="section-body">

            <div class="status-row">

                <div class="left">

                    Exam Status

                </div>

                <div class="right">

                    <span class="icon">

                        {{getIcon(data.EXM_Status)}}

                    </span>

                    <span class="badge"
                          [ngClass]="getClass(data.EXM_Status)">

                        {{getStatus(data.EXM_Status)}}

                    </span>

                </div>

            </div>


            <!-- <div class="status-row no-border">

                <div class="left">

                    Exam Date

                </div>

                <div class="right">

                    {{data.ExamEndAt | date:'dd MMM yyyy'}}

                </div>

            </div> -->

        </div>

    </div>

</div>